//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscBoltOutlined(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2C9.34784 2 6.80432 3.05359 4.92896 4.92896C3.05359 6.80432 2 9.34784 2 12C2 14.6522 3.05359 17.1957 4.92896 19.071C6.80432 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.071 19.071C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.80432 19.071 4.92896C17.1957 3.05359 14.6522 2 12 2ZM12 20C9.87827 20 7.84343 19.1572 6.34314 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84343 6.34314 6.34314C7.84343 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34314C19.1572 7.84343 20 9.87827 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1572 14.1217 20 12 20ZM13 6L7.13 13H11V18L16.87 11H13V6Z" fill="currentColor" /></svg>;
}
export default IconMiscBoltOutlined;